module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_3009.394022f3.png";